import { Briefcase, Loader2 } from "lucide-react";
import { glassCard } from "../../utils/glassStyles";

function JobCardSkeleton() {
  return (
    <div className={`rounded-2xl ${glassCard} p-6 animate-pulse overflow-hidden relative`}>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="flex gap-3 mb-4">
        <div className="w-12 h-12 rounded-xl bg-white/20 dark:bg-white/10 shrink-0" />
        <div className="flex-1 space-y-2.5 min-w-0">
          <div className="h-2.5 w-16 rounded-full bg-white/25 dark:bg-white/10" />
          <div className="h-4 w-full rounded-lg bg-white/30 dark:bg-white/10" />
        </div>
      </div>
      <div className="h-3 w-2/3 rounded-full bg-white/20 dark:bg-white/10 mb-3" />
      <div className="h-3 w-1/2 rounded-full bg-white/15 dark:bg-white/10 mb-5" />
      <div className="h-9 w-full rounded-xl bg-white/25 dark:bg-white/10" />
    </div>
  );
}

function LoaderContent({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center gap-5">
      <div className="relative">
        <div className="absolute -inset-3 rounded-3xl bg-primary/20 blur-xl animate-pulse" />
        <div className={`relative rounded-2xl ${glassCard} p-6 shadow-lg`}>
          <div className="relative flex items-center justify-center w-14 h-14">
            <Loader2 className="w-10 h-10 animate-spin text-primary absolute" />
            <Briefcase className="w-5 h-5 text-primary/80 relative z-10" />
          </div>
        </div>
      </div>
      <div className="text-center space-y-2">
        <p className="text-sm font-semibold tracking-wide text-foreground">{label}</p>
        <div className="flex items-center justify-center gap-1.5">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-2 h-2 rounded-full bg-primary animate-bounce"
              style={{ animationDelay: `${i * 160}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Loader({
  className = "",
  size = "default",
  variant = "full",
  label = "Loading...",
  count = 12,
}) {
  if (variant === "jobs") {
    return (
      <div className={`py-8 ${className}`}>
        <div className="flex justify-center mb-8">
          <LoaderContent label={label || "Finding jobs for you..."} />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: count }, (_, i) => (
            <JobCardSkeleton key={i} />
          ))}
        </div>
      </div>
    );
  }

  const sizeClasses = {
    sm: "w-6 h-6",
    default: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  if (variant === "inline") {
    return (
      <div className={`py-16 flex items-center justify-center ${className}`}>
        <LoaderContent label={label} />
      </div>
    );
  }

  if (variant === "spinner") {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <Loader2 className={`${sizeClasses[size]} animate-spin text-primary`} />
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex items-center justify-center bg-transparent ${className}`}>
      <LoaderContent label={label} />
    </div>
  );
}
